import React, { useEffect, useState } from 'react';

//Components
import MainCard from '../../../components/MainCard/MainCard';
import TabelaListagem from '../../../components/TabelaListagem/TabelaListagem';
import Loading from '../../../components/Loading/Loading';
import FichaTransportador from '../../../views/Cadastros/Transportadores/FichaTransportador';

//Api
import dashboard_api from '../../../api/dashboard_api';

//Helpers
import { showMessage } from '../../../helpers/message';
import mascaras from '../../../helpers/mascaras';

//Contants
import { actionsTable } from '../../../constants/MaterialTable';


function ModalidadesCredenciamento({ btnVoltar, id, modalidade, statusCredenciamento }) {
    const [loading, setLoading] = useState(false);

    //Estado para pegar o transportador
    const [transportador, setTransportador] = useState(null);

    //Estado para pegar os transportadores
    const [listTransportadores, setListTransportadores] = useState([]);

    //Headers com filtro de credenciamento
    const headersCredenciamento = [
        { value: "Fantasia", objectValue: "fantasia", align: "left" },
        { value: "Telefone", objectValue: "fone", align: "left" },
        { value: "Endereço", objectValue: "endereco", align: "left" },
        { value: "Validade do credenciamento", objectValue: "validadeCredenciamento", align: "left" },
        { value: "Veiculos Credenciados", objectValue: "qtdVeiculos", align: "right" },
        { value: "Contratos", objectValue: "contratos", align: "left" },
    ];

    const laodCredeciamentoTransportadores = () => {
        setLoading(true);
        dashboard_api.TransportadoresPorModalidade({ modalidadeId: id, statusCredenciamento: statusCredenciamento }).then(response => {
            response.data = response.data.map(value => {
                value.fone = !!value.fone ? mascaras.telefoneMask(value.fone) : "";
                return value;
            })
            setListTransportadores(response.data)
        })
            .catch(e => showMessage("Aviso", e.message, "error", null))
            .finally(f => setLoading(false));
    }

    const handleTransportador = (row) => {
        setTransportador(row)
    }

    const actions = [actionsTable.visualizar(handleTransportador)]

    useEffect(() => {
        laodCredeciamentoTransportadores();
    }, []);

    if (transportador)
        return <FichaTransportador
            id={transportador.id}
            btnVoltar={() => setTransportador(null)}
        />

    return <MainCard
        title={modalidade}
        noCard
        btnVoltarInTop={btnVoltar}
    >
        {loading && <Loading />}
        <TabelaListagem
            title='Lista de credenciamento por modalidade'
            actions={actions}
            headers={headersCredenciamento}
            items={listTransportadores}
            options={{ print: false, search: true, pagination: true }}
        />
    </MainCard>
}

export default ModalidadesCredenciamento;